import "../../App.css";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { AnimIcon, MenuBtnSmall } from "../ui/Icons";
import { Switch } from "../ui/Icons";
import { NavbarProps, NavMenuProps } from "../common/types";
import GsapMagnetic from "../ui/GsapMagnetic";
import { transitionSlide } from "../ui/Animation/anim";
import transitionStyle from "../ui/Animation/transition.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { navItems } from "../../utils/navItems";

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  background-color: ${({ theme }) => theme.body};

  a {
    position: relative;
    color: ${({ theme }) => theme.text};
    margin: 0 2rem;
    text-decoration: none;
    padding: 8px;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 10px;
      height: 10px;
      background-color: ${({ theme }) => theme.text};
      border-radius: 50%;
      transform: translateX(-50%) scale(0);
      transition: transform 0.3s ease-in-out;
    }

    &:hover::after,
    &.active::after {
      transform: translateX(-50%) scale(1);
    }
  }

  .nav-links {
    display: flex;
    align-items: center;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SmNav = styled.nav`
  background-color: transparent;
  position: relative;
  display: flex;
  height: 79px;
  // justify-content: space-between;
  // padding: 0.6rem;
  align-items: center;
  z-index: 1001;
  // border: 1px solid green;

  @media (max-width: 576px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
`;
const CoverBar = styled.div`
  @media (max-width: 576px) {
    // border: 1px solid red;
    background-color: ${({ theme }) => theme.body};
    z-index: 999;
    height: 79px;
    top: 0;
    left: 0;
    right: 0;
    position: fixed;
  }
`;

export const SmNavbar: React.FC<NavMenuProps> = ({
  toggleMenu,
  isDarkMode,
  isSideMenuOpen,
}) => (
  <>
    <SmNav>
    <div style={{position:"relative", left: "10px"}}><AnimIcon isDarkMode={isDarkMode ?? false} /></div>
   <div style={{zIndex: '2', position: 'absolute', right: '10px'}}>
   <MenuBtnSmall
        isDarkMode={isDarkMode}
        toggleMenu={toggleMenu}
        isSideMenuOpen={isSideMenuOpen}
      />
   </div>

       {/* This  div aligns same as the side menu preventing clicks to close the side menu */}
  <AnimatePresence mode="wait">
  {isSideMenuOpen && (
      <motion.div
        variants={transitionSlide}
        initial="initial"
        animate="enter"
        exit="exit"
        className={`menuSqMenuBtn ${transitionStyle.conditionedCover}`}
        onClick={(e) => e.stopPropagation()}
      ></motion.div>
    )}
  </AnimatePresence>
    </SmNav>

    <CoverBar></CoverBar>

  </>
);

const Navbar: React.FC<NavbarProps> = ({ toggleTheme, isDarkMode }) => (
  <Nav>
    <AnimIcon isDarkMode={isDarkMode} />
    <div className="nav-links App-header-text-style">
      {navItems.map((data, index) => {
        if(data.href !== '/'){   
            return (
              <GsapMagnetic key={index} $maxTranslation={10} $magneticOverflow="visible">
              <NavLink key={index} to={data.href}>{data.title}</NavLink>
            </GsapMagnetic>
            );
          }
          return null; // Explicitly return null for '/'
          })}

      <GsapMagnetic $maxTranslation={10} $magneticOverflow="visible">
        <Switch toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
      </GsapMagnetic>
    </div>
  </Nav>
);

export default React.memo(Navbar);
